// extracted by mini-css-extract-plugin
export var cardLayout = "_1w-1";
export var paginationContainer = "_1w-0";